import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Euro, TrendingUp } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface PricingInfoProps {
  priceInfo: {
    monthly?: number;
    quarterly?: number;
    annual?: number;
    drop_in?: number;
    trial?: number;
    currency?: string;
  };
}

export const PricingInfo = ({ priceInfo }: PricingInfoProps) => {
  // Generate dummy pricing if not provided
  const defaultPricing = {
    monthly: 49,
    quarterly: 129,
    annual: 399,
    drop_in: 15,
    trial: 0,
    currency: 'EUR'
  };

  const pricing = (priceInfo && Object.keys(priceInfo).length > 1) ? priceInfo : defaultPricing;
  const currency = pricing.currency || 'EUR';
  
  const pricingOptions = [
    { label: 'Mensual', value: pricing.monthly, icon: '📅' },
    { label: 'Trimestral', value: pricing.quarterly, icon: '📆', badge: 'Ahorra 13%' },
    { label: 'Anual', value: pricing.annual, icon: '🎯', badge: 'Mejor Oferta - Ahorra 32%' },
    { label: 'Sesión Individual', value: pricing.drop_in, icon: '💪' },
    { label: 'Clase de Prueba GRATIS', value: pricing.trial, icon: '🎁', badge: 'Sin Compromiso' },
  ];

  const availableOptions = pricingOptions.filter(option => option.value);

  if (availableOptions.length === 0) return null;

  return (
    <Card className="border-2 border-green-500/20 shadow-lg">
      <CardHeader className="bg-gradient-to-r from-green-50/50 to-emerald-50/30 dark:from-green-950/20 dark:to-emerald-950/10">
        <CardTitle className="flex items-center gap-2">
          <Euro className="w-5 h-5 text-green-600 dark:text-green-400" />
          <span className="text-xl">Precios y Membresías</span>
        </CardTitle>
        <p className="text-sm text-muted-foreground mt-1">Opciones flexibles para todos</p>
      </CardHeader>
      <CardContent>
        <div className="grid gap-3">
          {availableOptions.map((option, index) => (
            <div
              key={index}
              className="flex justify-between items-center p-3 rounded-lg border hover:bg-accent/50 transition-colors"
            >
              <div className="flex items-center gap-3">
                <span className="text-2xl">{option.icon}</span>
                <div>
                  <p className="font-medium">{option.label}</p>
                  {option.badge && (
                    <Badge variant="secondary" className="mt-1 text-xs">
                      <TrendingUp className="w-3 h-3 mr-1" />
                      {option.badge}
                    </Badge>
                  )}
                </div>
              </div>
              <div className="text-right">
                {option.value === 0 ? (
                  <p className="text-2xl font-bold text-green-600 dark:text-green-400">GRATIS</p>
                ) : (
                  <>
                    <p className="text-2xl font-bold text-primary">
                      {option.value}€
                    </p>
                    <p className="text-xs text-muted-foreground">{currency}</p>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
